import React from "react";
import { Link } from "react-router-dom";
import { SUPPORT_EMAIL } from "../constants/supportContact";
import "./Footer.css";

const FOOTER_COLUMNS = [
  {
    heading: "Product",
    links: [
      { to: "/pricing", label: "Pricing" },
      { to: "/why-haastia", label: "Why Haastia" },
      { to: "/example", label: "Example booking page" },
    ],
  },
  {
    heading: "Company",
    links: [
      { to: "/about", label: "About" },
      { to: "/contact", label: "Contact" },
      { to: "/help", label: "Help center" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { to: "/terms", label: "Terms & conditions" },
      { to: "/privacy", label: "Privacy policy" },
    ],
  },
];

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="haastia-footer">
      <div className="haastia-footer__inner">
        <div className="haastia-footer__grid">
          <div className="haastia-footer__brand">
            <Link to="/" className="logo haastia-footer__logo">
              haastia
            </Link>
            <p className="haastia-footer__tagline">
              Booking, calendar and payments for independent professionals and teams.
            </p>
          </div>

          {FOOTER_COLUMNS.map((column) => (
            <nav
              className="haastia-footer__col"
              aria-label={`${column.heading} links`}
              key={column.heading}
            >
              <p className="eyebrow eyebrow--muted haastia-footer__heading">{column.heading}</p>
              {column.links.map((link) => (
                <Link to={link.to} key={`${column.heading}-${link.label}`}>
                  {link.label}
                </Link>
              ))}
            </nav>
          ))}
        </div>

        <div className="haastia-footer__bottom">
          <span>&copy; {year} Haastia</span>
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
